import React from 'react';
import ApkState from './apkState/ApkState';
import ApkControlPanel from './components/ApkControlPanel/ApkControlPanel';
import Apk from './components/Apk/Apk';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const ApkPage: React.FC = () => {
	return (
		<ApkState>
			<div className={style.container} data-test="ApkPage">
				<ApkControlPanel />
				<Apk />
				<ModalWindows />
			</div>
		</ApkState>
	);
};

export default ApkPage;
